// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"360aba01","867":"499103ce","879":"360aba01"}[chunkId] + ".chunk.css";
};